import { QUERY_PARAMS } from '@constants/query-params.const';

export const LOGIN_REQUIRED_PARAMS = [
  QUERY_PARAMS.CLIENT_ID,
  QUERY_PARAMS.REDIRECT_URI,
  QUERY_PARAMS.RESPONSE_TYPE,
  QUERY_PARAMS.SOLUTION,
];
